import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useStripe } from '@/hooks/useStripe';
import { CreditCard } from 'lucide-react';
import { toast } from 'sonner';

export const AccountBillingPage = () => {
  const { createPortalSession } = useStripe();

  const handleManageBilling = async () => {
    try {
      toast.info('Redirecting to billing portal...');
      toast.info('Redirecting to billing portal...');
      const returnUrl = window.location.href;
      const { url } = await createPortalSession.mutateAsync(returnUrl);
      window.open(url, '_blank');
    } catch {
      toast.error('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="space-y-6">
      <Card className="flex items-center justify-between p-5">
        <div className="flex items-center gap-4">
          <div className="w-10 h-10">
            <CreditCard />
          </div>
          <div>
            <h3 className="font-semibold">Billing Portal</h3>
            <p className="text-sm text-muted-foreground">
              Manage your subscription and payment details
            </p>
          </div>
        </div>
        <Button
          onClick={handleManageBilling}
          isLoading={createPortalSession.isPending}
          disabled={createPortalSession.isPending}>
          Manage billing
        </Button>
      </Card>
    </div>
  );
};

const SkeletonLoader = () => {
  return (
    <div className="space-y-6">
      <Card className="flex items-center justify-between p-5">
        <div className="flex items-center gap-4">
          <Skeleton className="w-10 h-10 rounded" />
          <div className="space-y-2">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-4 w-48" />
          </div>
        </div>
        <Skeleton className="h-10 w-32" />
      </Card>
    </div>
  );
};
